import { authResource } from './Auth';
export const OrganizationEncryptionAccessorsResource = authResource({
    path: '/organizations/:organizationId/encryptions/accessors/:accessorId?',
    searchParams: {},
    schema: {}
})
    .extend('getList', {
    schema: { count: 0, items: [''] }
})
    .extend((BaseResource) => ({
    getBulkList: BaseResource.getList.extend({
        method: 'POST',
        body: {
            encryptionGUIDs: [],
            fetch: 0,
            offset: 0,
            organizationId: '',
            sortBy: '',
            userId: ''
        },
        schema: { count: 0, items: [''] },
        sideEffect: false
    })
}));
